import "./style.less";

import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslate } from "@netless/flat-i18n";
import { ChatMessages, ChatMessagesProps } from "./ChatMessages";
import { ChatTabTitle, ChatTabTitleProps } from "./ChatTabTitle";
import { WhiteboardStore } from "@netless/flat-stores";

export type ChatPanelProps = {
    totalUserCount?: number;
    onClickTotalUsersCount?: () => void;
    readOnly?: boolean;
    whiteboardStore?: WhiteboardStore;
    cc?: React.ReactNode;
    messagesBoxRef?: (el: HTMLDivElement | null) => void;
} & ChatTabTitleProps &
    Omit<ChatMessagesProps, "visible">;

export const ChatPanel = observer<ChatPanelProps>(function ChatPanel(props) {
    const t = useTranslate();
    const whiteboard = props.whiteboardStore;
    const collapsed = whiteboard?.isRightSideClose;
    return (
        <div className="chat-panel">
            {!props.readOnly && (
                <div className="chat-panel-header">
                    <ChatTabTitle>
                        <span>{t("messages")}</span>
                    </ChatTabTitle>
                    {/* {props.totalUserCount && (*/}
                    {/*    <span className="chat-tab-subtitle" onClick={props.onClickTotalUsersCount}>*/}
                    {/*        {t("total-users-count", { count: props.totalUserCount })}*/}
                    {/*    </span>*/}
                    {/* )}*/}
                    <button
                        className="button-close"
                        onClick={() => whiteboard?.setRightSideClose(!collapsed)}
                    >
                        <svg
                            fill="none"
                            height="16"
                            viewBox="0 0 16 16"
                            width="16"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                clipRule="evenodd"
                                d="M2.81817 2.81767C3.01973 2.61611 3.34653 2.61611 3.54809 2.81767L8.00033 7.26992L12.4526 2.81767C12.6541 2.61611 12.9809 2.61611 13.1825 2.81767C13.384 3.01924 13.384 3.34603 13.1825 3.54759L8.73024 7.99983L13.1825 12.4521C13.384 12.6536 13.384 12.9804 13.1825 13.182C12.9809 13.3836 12.6541 13.3836 12.4526 13.182L8.00033 8.72975L3.54808 13.182C3.34652 13.3836 3.01972 13.3836 2.81816 13.182C2.6166 12.9804 2.6166 12.6536 2.81816 12.4521L7.27041 7.99983L2.81817 3.54759C2.61661 3.34603 2.61661 3.01924 2.81817 2.81767Z"
                                fill="#404040"
                                fillRule="evenodd"
                            />
                        </svg>
                    </button>
                </div>
            )}
            <ChatMessages {...props} visible readOnly={props.readOnly} />
            {props.cc && <div className="chat-panel-cc">{props.cc}</div>}
        </div>
    );
});

export { ChatMessage } from "./ChatMessage";

export * from "./types";
